import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import ReactDataGrid from 'react-data-grid';
import { SkyLightStateless } from 'react-skylight';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';
import _ from 'lodash';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import { dateFormat, toFromDates } from '../Common/cleanDates';
import ConfirmActionModal from '../Common/confirmActionModal';
import CashFormatter from '../Common/cashFormatter';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../../actions/root_url';

import checkPermission from '../Common/permissions';
import dateFilterRadios from '../Common/dateFilterRadios';

const isRivera = (ROOT_API_URL === 'https://rivera-scm.truckxi.com/api/') || (ROOT_API_URL === 'https://rvrstage-scm.truckxi.com/api/');
const isTN = ROOT_API_URL === 'https://tn-scm.truckxi.com/api/' || ROOT_URL === 'https://tn-scm.truckxi.com/api/';
const isUSPride = ROOT_API_URL === 'https://uspride-scm.truckxi.com/api/' || ROOT_URL === 'https://uspride-scm.truckxi.com/api/'; 
const isOCM = ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/' || ROOT_URL === 'https://ocm-scm.truckxi.com/api/'; 
const isATL = ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || ROOT_URL === 'https://alton-scm.truckxi.com/api/';
const isRS = ROOT_API_URL === 'https://redstone-scm.truckxi.com/api/' || ROOT_URL === 'https://redstone-scm.truckxi.com/api/';
const isLO = ROOT_API_URL === 'https://lonni-scm.truckxi.com/api/' || ROOT_URL === 'https://lonni-scm.truckxi.com/api/';

class ReceiveHistoryList extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton,

      createOpen: false,
      editRecPermissionOpen: false,
      statusOpen: false,
      case: null,

      rows: [],
      selectedRows: [],
      editedRows: [],
      filters: {},
      sortColumn: null,
      sortDirection: null,
      gourpOpen: false,

      receiveHistoryLine: {
        rows: [],
        selectedRows: null,
        editedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
        gourpOpen: false,
      },

      PdfFrameLoaded: true,
      Days: '7',
      FromDate: undefined,
      ToDate: undefined,

      WarehouseReceive_id: null,
    };

    this.handleResize = this.handleResize.bind(this);

    this.openCreate = this.openCreate.bind(this);
    this.closeCreate = this.closeCreate.bind(this);
    this.receiveDetail = this.receiveDetail.bind(this);
    this.autoPutaway = this.autoPutaway.bind(this);
  }

  componentWillMount() {
    this.props.setDefaultOfForm('Days', '7', 'receiveHistoryList');
    // this.props.fetchReceiveHistoryByDate(0, 0, '7');
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
    this.props.fetchReceiveHistoryByDate(0, 0, '7');
  }

  // Once purchaseOrders is ready, reset state.
  componentWillReceiveProps(nextProps) {
    if (nextProps.passcodeVerified && !this.props.passcodeVerified) {
      this.props.setPasscodeVerificationStatus();
      this.receiveDetailRedirect();
    }
    if (nextProps.FromDate && nextProps.FromDate !== this.props.FromDate) {
      this.setState({ fromDate: nextProps.FromDate }, this.fetchReceiveHistoryByDetails);
    }
    if (nextProps.ToDate && nextProps.ToDate !== this.props.ToDate) {
      this.setState({ toDate: nextProps.ToDate }, this.fetchReceiveHistoryByDetails);
    }
    if (nextProps.currentReceiveHistoryDetail && nextProps.currentReceiveHistoryDetail != this.props.currentReceiveHistoryDetail) {
      if (nextProps.currentReceiveHistoryDetail.Warehouse_Receive_Line_Completed) {
        const newRows = [...nextProps.currentReceiveHistoryDetail.Warehouse_Receive_Line_Completed];
        newRows.map((newRow) => {
          newRow.RcvUnitPrice = newRow.RcvUnitPrice ? newRow.RcvUnitPrice : newRow.FOBUnitPrice;
        });
        const receiveHistoryLine = { ...this.state.receiveHistoryLine, rows: newRows };
        this.setState({ receiveHistoryLine });
      } else {
        const receiveHistoryLine = { ...this.state.receiveHistoryLine, rows: nextProps.currentReceiveHistoryDetail.Warehouse_Receive_Line };
        this.setState({ receiveHistoryLine });
      }
    }
    if (nextProps.checkPermissionSuccess && nextProps.checkPermissionSuccess !== this.props.checkPermissionSuccess) {
      if (nextProps.checkPermissionSuccess.manager) {
        this.closeEditRecPermission();
        this.setState({ editRecPermission: true });
        this.props.voidReceiving(this.state.selectedRows[0].WarehouseReceive_id);
      }
    }

    if (nextProps.voidStatus) {
      this.openStatusModal();
    }

    if (nextProps.currentReceiveHistory && nextProps.currentReceiveHistory !== this.props.currentReceiveHistory) {
      let receives = nextProps.currentReceiveHistory.Invoices;

      // filter out purchase returns from warehouse receiving list
      receives = _.filter(
        receives,
        receive => (receive.PurchaseReturn_id === undefined),
      );
      //
      // receives.map((receive) => {
      //   receive.VendorName = receive.Purchase.Vendor.Name;
      //   receive.FinalPrice = receive.Purchase.FinalPrice;
      //   receive.TotalPrice = receive.Purchase.TotalPrice;
      // });
      this.setState({
        rows: receives,
      });
    }

    if (nextProps.warehouseReceivePdf && nextProps.warehouseReceivePdf !== this.props.warehouseReceivePdf) {
      this.setState({ PdfFrameLoaded: false });
    }
    if (nextProps.Days && nextProps.Days !== this.props.Days) {
      if (nextProps.Days !== '-1') {
        this.props.setDefaultOfForm('FromDate', null, 'receiveHistoryList');
        this.props.setDefaultOfForm('ToDate', null, 'receiveHistoryList');
      }
    }

    if ((typeof (this.props.FromDate) !== 'undefined') && (typeof (this.props.ToDate) !== 'undefined') && ((nextProps.FromDate !== this.props.FromDate) || (nextProps.ToDate !== this.props.ToDate))) {
      let dateRange = -1;
      let FromDate = '1900-01-01';
      let ToDate = '3000-01-01';
      if (nextProps.FromDate != null) { FromDate = this.formatDate(nextProps.FromDate); }

      if (nextProps.ToDate != null) { ToDate = this.formatDate(nextProps.ToDate); }

      if (this.props.Days != null) { dateRange = this.props.Days; }
      if (this.props.voidStatus) { this.props.resetDeleteStatus(); }
      this.props.fetchReceiveHistoryByDate(FromDate, ToDate, dateRange);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded == false) {
      return false;
    }

    return true;
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  // Set purchaseOrders being selected to be currentReceive and navigate user to the edit page
  setCurrentReceive(e) {
    e.preventDefault();
    const currentReceive = this.state.selectedRows[0];
    this.props.selectReceive(currentReceive);
  }

  openCreate() { this.setState({ createOpen: true }); }
  closeCreate() { this.setState({ createOpen: false }); }

  openStatusModal = () => {
    this.setState({ case: 'voidStatus', statusOpen: true });
  }

  closeStatusModal = () => {
    this.props.resetDeleteStatus();
    this.setState({ statusOpen: false }, this.fetchReceiveHistoryByDetails(this.props.Days));
  }

  openEditRecPermission = () => {
    this.setState({ case: 'editRecPermission', editRecPermissionOpen: true });
  }

  closeEditRecPermission = () => {
    this.setState({ editRecPermissionOpen: false });
  }

  receiveDetail(e) {
    e.preventDefault();
    if (isRivera) {
      this.props.setConfirmPasscodeModalVisibility(true);
      return;
    }
    this.receiveDetailRedirect();
  }

  receiveDetailRedirect = () => {
    const currentReceiveHistory = this.state.selectedRows[0];
    this.props.resetCurrentReceiveHistory();
    this.props.selectReceiveHistory(currentReceiveHistory);
    this.context.router.push(`/inventories/receiveHistory/${currentReceiveHistory.PONum}`);
  }

  autoPutaway(e) {
    e.preventDefault();
    const currentReceiveHistory = this.state.selectedRows;
    const receiveHistory = currentReceiveHistory.map(history => history.WarehouseReceive_id);
    this.props.autoPutaway(receiveHistory);
  }

  handleResize() {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton });
  }

  clickNew(e) {
    e.preventDefault();
    // this.props.resetCurrentReceive();
    this.context.router.push('/inventories/receive/new');
  }

    fetchReceiveHistoryByDetails = (days) => {
      if (days !== '-1') {
        this.setState(
          { FromDate: undefined, ToDate: undefined, Days: days },
          () => { this.props.fetchReceiveHistoryByDate(this.state.FromDate, this.state.ToDate, this.state.Days); },
        );
      } else {
        this.setState(
          { Days: '-1' },
          () => { this.props.fetchReceiveHistoryByDate(this.state.FromDate, this.state.ToDate, this.state.Days); },
        );
      }
    }

    formatDate(date) {
      return dateFormat('YYYY-MM-DD', date);
      /*
        let formattedDate = date.getFullYear() + '-';

        formattedDate += date.getMonth()+1 + '-';
        if (date.getDate() < 10) {
          formattedDate += '0' + date.getDate();
        } else {
          formattedDate += date.getDate();
        }

        return formattedDate;
      */
    }

    IFrameIsLoaded = () => {
      if (!this.state.PdfFrameLoaded) {
        const pdfFrame = window.frames.Pdf;
        pdfFrame.focus();
        pdfFrame.print();
        this.setState({ PdfFrameLoaded: true });
      }
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
    renderTable() {
      if (this.props.isLoading && !this.props.error) return <Spinner />;
      else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>;

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the row select function
      const onRowSelect = (rows) => {
        const newRows = getRows();
        const selectedRows = [...this.state.selectedRows];
        rows.map(r => {
          newRows[r.rowIdx].isSelected = true;
          selectedRows.push(r.row);
        });
        this.setState({ rows: newRows, selectedRows });
      };

      const onRowsDeselected = (rows) => {
        const newRows = getRows();
        rows.map(r => {
          newRows[r.rowIdx].isSelected = false;
        });
        const selectedRows = [];
        newRows.forEach(row => {
          row.isSelected && selectedRows.push(row);
        })
        this.setState({
          rows: newRows,
          selectedRows,
         });
    };

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        const state = Object.assign({}, this.state, { sortColumn, sortDirection });
        this.setState(state);
      };

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        this.setState({ filters: newFilters });
      };


      // Handle the editable function
      const handleRowUpdated = (e) => {
        // merge updated row with current row and rerender by setting state
        const rows = this.state.rows.slice(0);
        const editedRows = this.state.editedRows.slice(0);
        Object.assign(rows[e.rowIdx], e.updated);
        // if the element is already edited, remove the old one.
        editedRows.forEach((element, index) => {
          if (element.Product_id === rows[e.rowIdx].Product_id) { editedRows.splice(index, 1); }
        }, this);
        // push the row into the editedRows array
        editedRows.push(rows[e.rowIdx]);
        this.setState({
          rows,
          editedRows,
        });
      };

      const DateFormatter = React.createClass({
        render() {
          if (this.props.value) {
            const date = new Date(this.props.value);
            return <span>{date.toString().slice(4, 15)}</span>;
          }
          return <span className="label label-danger">-</span>;
        },
      });

      const onRowClick = (rowIdx, row) => {
        const newRows = getRows();
        const selectedRows = [row];
        newRows.forEach(row => {
          row.isSelected = false;
        });
        newRows[rowIdx].isSelected = true;
        // const onRowSelect = (rows) => {
        //   this.setState(...this.state, { selectedRows: rows });
        // };
        this.setState({
          newRows,
          selectedRows,
        })

        if (row) {
          this.setState({
            WarehouseReceive_id: row.WarehouseReceive_id,
          })
          this.props.fetchReceiveHistoryDetailRecord(row.WarehouseReceive_id, row.Warehouse_ReceiveCompleted_id);
        }
      };

      // Column difinition
      const columns = [
        {
          key: 'PONum',
          name: <Translate value="po_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        ...(isUSPride || isATL || isRS) ? [{
          key: 'container_num',
          name: <Translate value="container_no" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 110,
        }] : [],
        {
          key: 'WarehouseReceiveNum',
          name: <Translate value="receive_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 110,
        },
        {
          key: 'InvoiceNum',
          name: <Translate value="invoice_vendor" />,
          resizable: true,
          sortable: true,
          width: 110,
          filterable: true,
        },
        {
          key: 'VendorName',
          name: <Translate value="vendor" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 200,
        },
        {
          key: 'PurchaseFinalPrice',
          name: <Translate value="po_final_dollarsign" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          formatter: CashFormatter,
        },
        {
          key: 'FinalPrice',
          name: <Translate value="receive_final_dollarsign" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          formatter: CashFormatter,
        },
        {
          key: 'InvoiceFinalPrice',
          name: <Translate value="invoice_final_dollarsign" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          formatter: CashFormatter,
        },
        {
          key: 'ArrivalStatus',
          name: <Translate value="arrival_status" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
        },
        {
          key: 'PaymentStatus',
          name: <Translate value="payment_status" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
        },
        {
          key: 'PostingDate',
          name: <Translate value="receive_date" />,
          resizable: true,
          sortable: true,
          filterable: true,
          formatter: DateFormatter,
          width: 90,
        },
        {
          key: 'Create_Username',
          name: <Translate value="created_by" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        {
          key: 'Modify_Username',
          name: <Translate value="modify" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        ...(isUSPride || isATL || isRS) ? [] : [{
          key: 'container_num',
          name: <Translate value="container_no" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 120,
        }],
        {
          key: 'Owner',
          name: <Translate value="owner" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        },
        {
          key: 'Note',
          name: <Translate value="note" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        },
      ];

      return (
        <Row>
          <Col xs={12}>
            <div style={{ maxWidth: '99%' }} id="ReceiveHistoryList-dataGrid1">
              <ReactDataGrid
                rowKey="WarehouseReceive_id"
                enableCellSelect
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={270}
                enableRowSelect="multi"
                onRowUpdated={handleRowUpdated}
                onRowClick={onRowClick}
                // onRowSelect={onRowSelect}
                rowSelection={{
                  showCheckbox: true,
                  enableShiftSelect: true,
                  onRowsSelected: onRowSelect,
                  onRowsDeselected: onRowsDeselected,
                  selectBy: {
                   isSelectedKey: 'isSelected'
                  }
                }}
              />
            </div>
          </Col>
        </Row>
      );
    }

    handleDownloadLabelClick = (WarehouseReceiveLine_id) => {
      const {
        WarehouseReceive_id,
      } = this.state;
      this.props.fetchLineLabel(WarehouseReceive_id, WarehouseReceiveLine_id);
    }
    
    handleSelectDetailAll = () => {
      
      const newRows = [...this.state.receiveHistoryLine.rows];
      const selectedRows = [];
      let index = 0;
      newRows.map((r) => {
        r.isSelected = true;
        selectedRows.push(r);
        index++;
      });
      const receiveHistoryLine = { ...this.state.receiveHistoryLine, rows: newRows, selectedRows };
      this.setState({ receiveHistoryLine });
    }

    handleDeselectDetailAll = () => {
      const newRows = [...this.state.receiveHistoryLine.rows];
      const selectedRows = null;
      let index = 0;
      newRows.map((r) => {
        r.isSelected = false;
      });
      const receiveHistoryLine = { ...this.state.receiveHistoryLine, rows: newRows, selectedRows };
      this.setState({ receiveHistoryLine });
    }
    
    renderDetailTable() {
      if (this.props.detailIsLoading && !this.props.error) return <Spinner />;
      else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{this.props.error}</div></ContentWrapper>;

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.receiveHistoryLine);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return Object.assign({}, rows[rowIdx]);
      };
      
      
      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        const state = Object.assign({}, this.state, { sortColumn, sortDirection });
        this.setState(state);
      };

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        this.setState({ filters: newFilters });
      };

      // Column difinition
      const IsFixedFormatter = React.createClass({
        render() {
          if (this.props.dependentValues.ProductType === 'Non-Fixed') {
            return <span>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
          }
          return <span>{this.props.value}</span>;
        },
      });
      
      let columns = [
        ...(!isLO) ? [{
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        }] : [],
        ...isOCM ? [{
          key: 'WarehouseReceiveLine_id',
          name: <Translate value="label" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: ({ value }) => {
            return <span style={{ cursor: 'pointer' }} onClick={() => this.handleDownloadLabelClick(value)}>download</span>
          },
        }] : [],
        {
          key: 'ProductRefNum',
          name: <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: isLO ? 160 : 70,
        },
        {
          key: 'ProductName',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 250,
        },
        {
          key: 'ProductDescription',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 200,
        },
        {
          key: 'PurchaseLine_Quantity',
          name: <Translate value="order_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 60,
        },
        {
          key: 'RcvQuantity',
          name: <Translate value="rcv_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          formatter: IsFixedFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'RcvTotalWeight',
          name: <Translate value="receive_total_wt" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        },
        {
          key: 'RcvUnitPrice',
          name: <Translate value="receive_unit_price" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: CashFormatter,
        },
        {
          key: 'RcvTotalPrice',
          name: <Translate value="receive_total_price" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 120,
          formatter: CashFormatter,
        },
        {
          key: 'Pallet',
          name: <Translate value="pallet" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 60,
        },
        {
          key: 'description',
          name: <Translate value="quality" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 150,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 150,
        },
        ...(isLO) ? [{
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        }] : [],
      ];

      if (isUSPride || isATL || isRS) {
        const index1 = _.findIndex(columns, { key: "RcvTotalWeight" });
        columns.splice(index1, 1);
        const index2 = _.findIndex(columns, { key: "Pallet" });
        const temp1 = {
          key: "PackageSize_1",
          name: <Translate value="volume_cft" />,
          resizable: true,
          width: 80,
          sortable: true,
        };
        columns.splice(index2, 0, temp1);
      }
      
      if (isTN) {
        columns = [
          {
            key: 'ProductNum',
            name: <Translate value="prod_num" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 100,
          },
          {
            key: 'ProductRefNum',
            name: <Translate value="ref_num" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 100,
          },
          {
            key: 'ProductName',
            name: <Translate value="prod_name" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 250,
          },
          {
            key: 'ProductDescription',
            name: <Translate value="description" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 200,
          },
          {
            key: 'pallet_barcode',
            name: <Translate value="plt_barcode" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 150,
          },
          {
            key: 'container_num',
            name: <Translate value="container_no" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 120,
          },
          {
            key: 'cpo_num',
            name: <Translate value="cpo_num" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 70,
          },
          {
            key: 'pc_per_box',
            name: <Translate value="pcs_ctn" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 80,
          },
          {
            key: 'box_qty',
            name: <Translate value="ctn_plt" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 80,
          },
          {
            key: 'RcvQuantity',
            name: <Translate value="total_pcs" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 80,
          },
        ];
      }

      return (
        <Row>
          <Col xs={12}>
            <div style={{ maxWidth: '99%' }} id="ReceiveHistoryList-dataGrid2">
              <ReactDataGrid
                rowKey="WarehouseReceiveLine_id"
                enableCellSelect
                onGridSort={handleGridSort}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={this.state.tableHeight / 2}
              />
            </div>
          </Col>
        </Row>
      );
    }

    renderIFrame() {
      if (this.props.warehouseReceivePdf) {
        const file = window.URL.createObjectURL(this.props.warehouseReceivePdf);
        return (
          <iframe style={{ display: 'none' }} onLoad={this.IFrameIsLoaded} id="Pdf" name="Pdf" src={file} />
        );
      }
    }

    renderPrint() {
      // default case where nothing is selected, causing button to be disabled
      let warehouseReceiveNums = null;

      // case where something is selected
      if (this.state.selectedRows) {
        if (this.state.selectedRows.length === 1) {
          warehouseReceiveNums = this.state.selectedRows[0].WarehouseReceiveNum;
        } else {
          const receivingNums = [];
          this.state.selectedRows.map((row) => {
            receivingNums.push(row.WarehouseReceiveNum);
          });
          warehouseReceiveNums = receivingNums.join(',');
        }
      }
      return (
        <Button
          bsStyle="primary"
          type="button"
          onClick={() => {
            this.props.printWarehouseReceive(warehouseReceiveNums);
          }}
          disabled={!warehouseReceiveNums}
        >
          <em className="fa fa-print" /><Translate value="print" />
        </Button>
      );
    }

    renderExportButton() {
      let { Days: days } = this.state;
      const { FromDate: f, ToDate: t } = this.state;
      days = days || 7;
      const { fromDate, toDate } = toFromDates(days, f, t);
      const params = `PostingDate__gte=${fromDate}&PostingDate__lte=${toDate}`;
      const token = localStorage.getItem('token');
      const url = `${ROOT_URL}v1/warehouse/search/excel?${params}&Bearer=${token}`;
      return (
        <Button
          bsStyle="success"
          type="button"
          href={url}
        >
          <em className="fa fa-download" />
          <Translate value="excel" />
        </Button>
      );
    }

    renderExportLinesButton() {
      const token = localStorage.getItem('token');
      let warehouseIds = [];
      const { selectedRows } = this.state;
      if (selectedRows && selectedRows.length > 0) {
        selectedRows.map((row) => {
          warehouseIds.push(row.WarehouseReceive_id);
        });
      }
      const url = `${ROOT_URL}v1/warehouse/receive-lines-export/${warehouseIds.join(",")}?Bearer=${token}`;
      return (
        <Button
          bsStyle="success"
          type="button"
          href={url}
          disabled={(!warehouseIds || warehouseIds.length < 1)}
        >
          <em className="fa fa-download" />
          <Translate value="excel_lines" />
        </Button>
      );
    }

    setToRangeSearch = () => {
      this.setState({ Days: '-1' });
    }

    setFromDate = (e) => {
      if (e > this.state.ToDate) {
        return;
      }
      this.setState({ FromDate: e });
    }

    setToDate = (e) => {
      if (e < this.state.FromDate) {
        return;
      }
      this.setState({ ToDate: e });
    }

    render() {
      const createDialogStyle = {
        width: '600px',
        marginLeft: '-15%',
      };
      const createStatueStyle = {
        width: '400px',
        marginLeft: '-15%',
      };
      let warehouseReceive_id = this.state.selectedRows && this.state.selectedRows[0] && this.state.selectedRows[0].WarehouseReceive_id;
      warehouseReceive_id = warehouseReceive_id || '';

      const editRecPermission = (<Translate value="permission_for_deleting_a_receiving" />);
      const statusModal = (<Translate value="status" />);
      let voidStatus = this.props.voidStatus || '';
      let voidStatusEnd = '';
      let apNum = 0;
      if (voidStatus.includes('AP records existed for this warehouse receive (APNum: ')) {
        apNum = voidStatus.match(/\[(.*?)\]/)[0];
        const voidStatusAP = 'ap_records_existed_for_this_warehouse_receive_(apnum:_';
        voidStatusEnd = ')__action_denied_';
        voidStatus = voidStatusAP;
      }
      if (voidStatus && !apNum) {
        voidStatus = voidStatus.toLowerCase().replace(/\s/g, '_');
        voidStatus = voidStatus.replace(/\./g, '_');
        voidStatus = voidStatus.replace(/\'/g, '');
      }
      return (
      //---------------
      // Begin HTML
      //---------------
        <ContentWrapper>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="warehouse_management" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active="true">
              <Translate value="receiving" />
            </Breadcrumb.Item>
          </Breadcrumb>
          <ButtonToolbar>
            { this.renderExportButton() }
            { isTN && this.renderExportLinesButton() }
          </ButtonToolbar>

          <Grid id="receive-history-list">
            { /* Date Range Pickers */ }
            <Row>
              <Col xs={12}>
                <Panel id="date-range-picker" className="form-horizontal">
                  <Row>
                    <Col xs={1}>
                      <h3 className="filter-title text-nowrap"><Translate value="receive_date" /><span className="colon">:</span></h3>
                    </Col>
                    <Col xs={11}>
                      {
                        dateFilterRadios({
                          handleOnClick: this.fetchReceiveHistoryByDetails,
                          setFromDate: this.setFromDate,
                          setToDate: this.setToDate,
                          setToRangeSearch: this.setToRangeSearch,
                          FromDate: this.state.FromDate,
                          ToDate: this.state.ToDate,
                          Days: this.state.Days,
                        })
                      }
                    </Col>
                  </Row>
                </Panel>
              </Col>
            </Row>
            { /* End Date Range Pickers */ }

            <Row>
              <Col xs={12}>
                <Panel className="position-relative table-collapse-fix">
                  <ButtonToolbar className="table-buttons">
                    <Button
                      bsStyle="warning"
                      type="button"
                      disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1 || !checkPermission('change_receive')}
                      onClick={this.receiveDetail}
                    >
                      <em className="fa fa-pencil" /><Translate value="edit" />
                    </Button>
                    {/*
                      <Button
                      bsStyle="primary"
                      type="button"
                      onClick={this.autoPutaway}>
                      <em className="fa fa-plus" /><Translate value="auto_putaway" />
                      </Button>
                    */}
                    <Button
                      bsStyle="danger"
                      type="button"
                      onClick={this.openEditRecPermission}
                      disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1 || !checkPermission('delete_receive')}
                    >
                      <em className="fa fa-trash" /><Translate value="void" />
                    </Button>
                    {this.renderPrint()}
                  </ButtonToolbar>

                  { this.renderTable() }
                </Panel>
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <h2><Translate value="receive_details" /></h2>
                <Panel className="mb0">
                  { this.renderDetailTable() }
                </Panel>
              </Col>
            </Row>
          </Grid>
          {this.renderIFrame()}
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.editRecPermissionOpen} onCloseClicked={() => { this.closeEditRecPermission(); }} title={editRecPermission}>
            <ConfirmActionModal
              case={this.state.case}
              checkPermission={this.props.checkPermission}
              checkPermissionSuccess={this.props.checkPermissionSuccess}
            />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createStatueStyle} isVisible={this.state.statusOpen} onCloseClicked={() => { this.closeStatusModal(); }} title={statusModal}>
            <ConfirmActionModal
              case={this.state.case}
              voidStatus={voidStatus}
              voidStatusEnd={voidStatusEnd}
              apNum={apNum}
            />
          </SkyLightStateless>
        </ContentWrapper>
      //---------------
      // End HTML
      //---------------
      );
    }
}


export default ReceiveHistoryList;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/receiveHistoryList.jsx